import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  container: {
    marginTop: '24px',
    marginBottom: '8px'
  },
  title: {
    display: 'flex',
    marginBottom: '4px',
    textTransform: 'capitalize'
  },
  autocomplete: {
    minWidth: '1344px',
    maxHeight: '250px',
    overflow: 'scroll'
  },
  error: {
    border: '1px solid #d32f2f',
    borderRadius: '4px'
  },
  errorMessage: {
    color: '#d32f2f',
    fontSize: '13px',
    fontWeight: 500,
    marginBottom: '6px'
  }
}));
